/* eslint-disable getter-return, warp-drive/no-legacy-request-patterns */
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import Controller from '@ember/controller';

import { isEmpty } from '@ember/utils';

export default class SidekickController extends Controller {
  @action
  setPageId(value) {
    this.pageId = value;
  }

  queryParams = ['pageId'];

  // Services
  @service
  store;

  @tracked pageId = '';

  get currentPage() {
    if (isEmpty(this.pageId)) {
      return;
    }
    return this.store.peekRecord('posts/page', this.pageId);
  }
}
